var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"dynamic-data-field-attributes"},[(_vm.value)?_c('ControlsTree',{attrs:{"controls":_vm.value.controls,"path":"attributes","allowPopoutsInRoot":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }